import { render, staticRenderFns } from "./ComDesc.vue?vue&type=template&id=5eb777d8&scoped=true"
import script from "./ComDesc.vue?vue&type=script&lang=js"
export * from "./ComDesc.vue?vue&type=script&lang=js"
import style0 from "./ComDesc.vue?vue&type=style&index=0&id=5eb777d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb777d8",
  null
  
)

export default component.exports